function compontjs(Vue) {
  if (compontjs.installed) {
    return
  }
//vant 组件

}

export default compontjs



// WEBPACK FOOTER //
// ./src/assets/globalJS/compont.js